declare const $: any;

export function OwlCarouselDirective($timeout: ng.ITimeoutService) {
  'ngInject';

  var directive = {
    link: link,
    restrict: 'AE',
    scope: {
      option: '='
    }
  };
  return directive;

  function link(
    scope: any,
    element: ng.IRootElementService,
    attrs: ng.IAttributes
  ) {
    setTimeout(() => {
      let carousel = $(element[0]);
      if (
        carousel.parents('[carousel-items]') &&
        carousel.parents('[carousel-items]').attr('carousel-items')
      ) {
        scope.option.items = parseInt(
          carousel.parents('[carousel-items]').attr('carousel-items')
        );
        scope.option.responsive[1200].items = parseInt(
          carousel.parents('[carousel-items]').attr('carousel-items')
        );
        scope.option.itemsDesktop = [
          1199,
          parseInt(carousel.parents('[carousel-items]').attr('carousel-items'))
        ];
      }
      if (
        carousel.parents('[carousel-items-md]') &&
        carousel.parents('[carousel-items-md]').attr('carousel-items-md')
      ) {
        scope.option.responsive[768].items = parseInt(
          carousel.parents('[carousel-items-md]').attr('carousel-items-md')
        );
        scope.option.itemsDesktopSmall = [
          979,
          parseInt(
            carousel.parents('[carousel-items-md]').attr('carousel-items-md')
          )
        ];
      }
      if (
        carousel.parents('[carousel-items-sm]') &&
        carousel.parents('[carousel-items-sm]').attr('carousel-items-sm')
      ) {
        scope.option.responsive[460].items = parseInt(
          carousel.parents('[carousel-items-sm]').attr('carousel-items-sm')
        );
        scope.option.itemsTablet = [
          979,
          parseInt(
            carousel.parents('[carousel-items-sm]').attr('carousel-items-sm')
          )
        ];
      }
      if (
        carousel.parents('[carousel-items-xs]') &&
        carousel.parents('[carousel-items-xs]').attr('carousel-items-xs')
      ) {
        scope.option.responsive[0].items = parseInt(
          carousel.parents('[carousel-items-xs]').attr('carousel-items-xs')
        );
        scope.option.itemsMobile = [
          479,
          parseInt(
            carousel.parents('[carousel-items-xs]').attr('carousel-items-xs')
          )
        ];
      }
      if (
        carousel.parents('[carousel-nav]') &&
        carousel.parents('[carousel-nav]').attr('carousel-nav')
      ) {
        scope.option.nav =
          carousel.parents('[carousel-nav]').attr('carousel-nav') === 'true';
        scope.option.navigation =
          carousel.parents('[carousel-nav]').attr('carousel-nav') === 'true';
      }
      if (
        carousel.parents('[carousel-loop]') &&
        carousel.parents('[carousel-loop]').attr('carousel-loop')
      ) {
        scope.option.loop =
          carousel.parents('[carousel-loop]').attr('carousel-loop') === 'true';
      }
      if (
        carousel.parents('[carousel-autoplay]') &&
        carousel.parents('[carousel-autoplay]').attr('carousel-autoplay')
      ) {
        scope.option.autoplay =
          carousel.parents('[carousel-autoplay]').attr('carousel-autoplay') ===
          'true';
        scope.option.autoPlay =
          carousel.parents('[carousel-autoplay]').attr('carousel-autoplay') ===
          'true';
      }
      if (
        carousel.parents('[carousel-rtl]') &&
        carousel.parents('[carousel-rtl]').attr('carousel-rtl')
      ) {
        scope.option.rtl =
          carousel.parents('[carousel-rtl]').attr('carousel-rtl') === 'true';
      }
      if (
        carousel.parents('[carousel-dots]') &&
        carousel.parents('[carousel-dots]').attr('carousel-dots')
      ) {
        scope.option.dots =
          carousel.parents('[carousel-dots]').attr('carousel-dots') === 'true';
        scope.option.pagination =
          carousel.parents('[carousel-dots]').attr('carousel-dots') === 'true';
      }
      if (
        carousel.parents('[carousel-autoplay-timeout]') &&
        carousel.parents('[carousel-autoplay-timeout]')
      ) {
        scope.option.autoplayTimeout = parseInt(
          carousel
            .parents('[carousel-autoplay-timeout]')
            .attr('carousel-autoplay-timeout')
        );
      }
      carousel.owlCarousel(scope.option);
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/directives/owlcarousel/owlcarousel.ts